export default "__VITE_ASSET__C7UhApmO__"